import { locations } from "../../common/redux/action_locations";
import {
    FETCH_AGENT_SCORECARDS,
    AGENT_SCORECARDS_RECEIVED
} from "./constants";
import { CFAuthGetRef } from "auth";

export function fetchAgentScorecardsAction(filters) {
    return {
        type: FETCH_AGENT_SCORECARDS,
        fetchCall: fetchAgentScorecards,
        receivedAction: receivedAgentScorecardsAction,
        data: {
            filters,
            locations
        }
    };
}

Array.prototype.groupBy = function(prop) {
    return this.reduce(function(groups, item) {
        const val = item[prop];
        groups[val] = groups[val] || [];
        groups[val].push(item);
        return groups;
    }, {});
};

function fetchAgentScorecards(filters) {
    return CFAuthGetRef({
        url: process.env.REACT_APP_SCORECARD_API_URL + "/odata/Scorecard/?$expand=ScorecardManagementUnitMapping&$filter=ScorecardManagementUnitMapping/ManagementUnitId in (" + filters.managementUnitID + ") and isActive eq true and ScorecardManagementUnitMapping/ScorecardUserTypeId eq " + filters.scorecardUserTypeId,
        originURL: process.env.PUBLIC_URL,
        loaderName: "fetchAgentScorecards"
    });
}

function receivedAgentScorecardsAction(data) {
    let uiModelData = [];
    let scorecardIds = [];
    
    if(data.value && data.value.length > 0) {

        let groupedCards = data.value.groupBy("ScorecardId");

        Object.keys(groupedCards).forEach(function(cardId) {
            let card = groupedCards[cardId];
            let item = card.length ? card[0] : [];
            if(item) {
                uiModelData.push ({
                    managementUnitId: item.ScorecardManagementUnitMapping.ManagementUnitId,
                    scorecardId: item.ScorecardId,
                    scorecardKey: item.ScorecardKey,
                    scorecardTypeId: item.ScorecardTypeId,
                    scorecardDisplayName: item.ScorecardDisplayName,
                    isActive: item.IsActive,
                    toolTipText: item.ToolTipText
                });
                scorecardIds.push(item.ScorecardId);
            }
        });
    }

    return {
		type: AGENT_SCORECARDS_RECEIVED,
        scorecards: uiModelData,
        scorecardIds: scorecardIds
	};
}

export function closePerformanceMetricsDetailedView() {
    let viewScorecard = false;
    return {
        type: "VIEW_PERFORMANCE_METRICS_SCORECARD",
        viewScorecard: viewScorecard
    };
}

export function reducer(state, action) {
    switch (action.type) {
        case AGENT_SCORECARDS_RECEIVED:
            return {
                ...state,
                scorecards: action.scorecards,
                scorecardIds: action.scorecardIds
            };
        case "VIEW_PERFORMANCE_METRICS_SCORECARD":
        return {
            ...state,
            viewScorecard: action.viewScorecard
        };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/features/scorecard/redux/actions.js